module.exports = new __parcel__URL__("gold2.f2722292.png").toString();